import {
  AlertCircle,
  Calendar,
  CheckCircle,
  ChevronLeft,
  ChevronRight,
  CloudCheck,
  CloudOff,
  Copy,
  Edit,
  Eye,
  EyeOff,
  LogOut,
  Plus,
  RotateCcw,
  RotateCw,
  Search,
  SlidersHorizontal,
  Tag,
  Trash2,
  X,
  XCircle,
} from "lucide-react-native"
import React from "react"
import { Icon as GluestackIcon } from "./gluestack/icon"

// Icon mapping table
const iconMap = {
  "check-circle-outline": CheckCircle,
  "check-circle": CheckCircle,
  "exclamation-circle": AlertCircle,
  "x-circle-outline": XCircle,
  "x-circle": XCircle,
  "x-mark": X,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  filter: SlidersHorizontal,
  calendar: Calendar,
  cloudCheck: CloudCheck,
  "cloud-off": CloudOff,
  plus: Plus,
  add: Plus,
  search: Search,
  tag: Tag,
  edit: Edit,
  trash: Trash2,
  logout: LogOut,
  eye: Eye,
  "eye-slash": EyeOff,
  copy: Copy,
  "rotate-ccw": RotateCcw,
  "rotate-cw": RotateCw,
} as const

export type IconName = keyof typeof iconMap

export interface IconProps {
  name: IconName
  className?: string
  size?: "xs" | "sm" | "md" | "lg" | "xl"
}

export const Icon: React.FC<IconProps> = ({
  name,
  className,
  size = "md",
  ...props
}) => {
  const IconComponent = iconMap[name]

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in iconMap`)
    console.warn(`Icon name type:`, typeof name)
    console.warn(`Icon name value:`, name)
    console.warn(`Available icon names:`, Object.keys(iconMap))
    return null
  }

  return (
    <GluestackIcon
      as={IconComponent}
      className={className}
      size={size}
      {...props}
    />
  )
}
